import { render, staticRenderFns } from "./TopNav_NotificationsBell.vue?vue&type=template&id=82f48d12&"
import script from "./TopNav_NotificationsBell.vue?vue&type=script&lang=js&"
export * from "./TopNav_NotificationsBell.vue?vue&type=script&lang=js&"
import style0 from "./TopNav_NotificationsBell.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports